import { useEffect,useState } from "react";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useReminderDetail = ({leadID, page, pageSize}) => {
    const [contactData, setContactData] = useState([]);
    const [reminderData, setReminderData] = useState([]);
    const [interactions, setInteractions] = useState([]);
    const [accountOwnsership, setAccountOwnership] = useState([]);
    const [interactionsCount, setInteractionsCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    // const page = 1;
    // const pageSize = 5;

    const fetchData = async () => {
        try{
            const queryParams = new URLSearchParams({
                page: page.toString(),
                page_size: pageSize.toString()
            })
            if (leadID) {
                queryParams.append("lead_id", leadID.toString());
                
                const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_REMINDER.REMINDER_DETAILS}?${queryParams.toString()}`)
                
                setContactData(result.contact_data);
                setAccountOwnership(result.account_ownership);
                setReminderData(result.reminder_data);
                setInteractions(result.interactions);
                setInteractionsCount(result.interactions_count);
                setTotalPages(result.total_pages);
                    
            }else{
                // console.log("No lead ID provided");
                return;
            }
        }catch (error){
            console.error("Error fetching data:", error);
            return;
        }
    };

    useEffect(() => {
        fetchData();
    }, [leadID, page, pageSize]);

    const refetch = () => {
        fetchData();
    };

    return {contactData, accountOwnsership, reminderData, interactions, interactionsCount, totalPages, refetch};
}